import React, { useRef, useEffect, useState, useCallback } from 'react';
import LottieView from "../alex/Lottie";
import deviceRotateAnimation from './device-rotate.json';

const DeviceRotateAnimation = () => {
    const isDevicePortraitQuery = 'only screen and (orientation: portrait)';
    const animationRef = useRef(null);
    const mediaQueryRef = useRef(window.matchMedia(isDevicePortraitQuery));
    const [isDevicePortrait, setIsDevicePortrait] = useState(mediaQueryRef.current.matches);

    useEffect(() => {
        if (animationRef.current) {
            animationRef.current.play();
        }
    }, [animationRef.current]);

    // use useCallback here so that the function identity is stable
    // and can be removed from the media query
    const onDeviceOrientationChange = useCallback(event => {
        setIsDevicePortrait(event.matches);
        if (!animationRef.current) return;
        if (event.matches) animationRef.current.play();
        else animationRef.current.reset();
    }, []);

    useEffect(() => {
        const mediaQuery = mediaQueryRef.current;
        mediaQuery.addEventListener('change', onDeviceOrientationChange);
        return () => {
            mediaQuery.removeEventListener('change', onDeviceOrientationChange);
        };
    }, [onDeviceOrientationChange]);

    if (!isDevicePortrait) return null;

    return (
        <div className="device-rotate-warning">
            <LottieView
                ref={animationRef}
                source={deviceRotateAnimation}
                loop
                style={{ width: '50%', height: '50%' }}
            />
            <p>Please rotate your screen.</p>
        </div>
    );
};

export default DeviceRotateAnimation;
